/**
 * plugins/oauthLogin.js
 *
 * Dynamically injects the Google Identity Services and Facebook JS SDKs,
 * lazily loaded only when the login popup is opened.
 */
import config from '@/config/config';

let googleScriptLoaded = false;
let facebookScriptLoaded = false;

export function loadGoogleSdk() {
  if (googleScriptLoaded) return Promise.resolve();
  googleScriptLoaded = true;

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export function renderGoogleButton(container, onCredential) {
  return loadGoogleSdk().then(() => {
    window.google.accounts.id.initialize({
      client_id: config.oauthConfig.googleClientId,
      callback: (response) => onCredential(response.credential)
    });
    window.google.accounts.id.renderButton(container, {
      theme: 'outline',
      size: 'large',
      shape: 'rectangular',
      width: container.offsetWidth || 360
    });
  });
}

export function loadFacebookSdk() {
  if (facebookScriptLoaded) return Promise.resolve();
  facebookScriptLoaded = true;

  return new Promise((resolve) => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: config.oauthConfig.facebookAppId,
        cookie: true,
        xfbml: false,
        version: 'v19.0'
      });
      resolve();
    };

    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  });
}

export function facebookLogin(onAccessToken, onError) {
  loadFacebookSdk().then(() => {
    window.FB.login((response) => {
      if (response.authResponse) {
        onAccessToken(response.authResponse.accessToken);
      } else {
        onError();
      }
    }, { scope: 'email,public_profile' });
  });
}
